<p-dialog
  header="Kreiraj test korisnika"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '450px' }"
  (onHide)="handleClose()">
  <div class="p-fluid">
    <div class="p-field">
      <label for="tenantKey">PIB klijenta</label>
      <input
        id="tenantKey"
        type="text"
        pInputText
        [(ngModel)]="targetTenantKey"
        placeholder="Unesite PIB klijenta" />
    </div>
    <p class="p-text-secondary p-mt-2">
      Klijent mora odobriti ovaj zahtev pre nego što se kreira test korisnik sa ADMIN pravima.
      Test korisnik ističe 48h nakon odobrenja.
    </p>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      label="Otkaži"
      icon="pi pi-times"
      styleClass="p-button-text"
      (onClick)="handleClose()">
    </p-button>
    <p-button
      label="Pošalji zahtev"
      icon="pi pi-send"
      [loading]="isLoading"
      [disabled]="!targetTenantKey"
      (onClick)="handleSubmit()">
    </p-button>
  </ng-template>
</p-dialog>
